<template>
<div>
  <!--<div v-for="men in mens" track-by="$index" v-bind:key="men._id" data-tooltip="[{{ men.board }}] {{ men.created | moment 'MMMM Do YYYY, h:mm:ss a'}}">-->
  <div v-for="men in mens" track-by="$index" v-bind:key="men._id">
    <!--<div class="arrow"></div>-->
    <!-- <h3 class="popover-title {{ [men.send === user.username ? 'purple darken-4' : ''] }}" style="{{ [men.send === user.username ? 'color: white;' : ''] }}">-->
      <!-- <b>{{ men.send }} :</b>-->
      <!-- <md-icon right style="cursor:pointer;" @click="deleteMensaje(men, $index)" v-if="men.send === user.username">close</md-icon>-->
      <!--<md-icon right @click="editMen(men)" v-if="men.send === user.username">edit</md-icon>-->
      <!-- <span class="right">{{ men.created | moment 'h:mm:ss a, MM/DD/YY'}}</span>-->
    <!-- </h3>-->
   <!--<div class="popover-content menText">-->
      <span style="font-size: medium" v-if="men.type==='text'"><b> {{ men.send }} :</b> {{ men.body }}</span>
      <!-- <span class="right" style="font-size: small; color:#aaa;">{{ men.created | moment 'h:mm:ss a, MM/DD/YY'}}</span>-->

      <!-- <span class="right" style="font-size: small; color:#aaa;">[{{ men.board }}] {{ men.created | moment 'h:mm:ss'}}</span>-->
      <span class="right" style="font-size: small; color:#aaa;">{{ men.created | moment 'h:mm:ss'}}</span>

      <!--<div v-if="men.type==='file'">
        <img v-if="isImage(men.body)" @click="showImage()" class="col s8 m8 l8" v-bind:src="imageUrl(men.body.name) @error="imageUrlAlt""
             alt="">
        <md-button v-else class="waves-effect waves-light purple darken-4" @click="openInNewTab(men.body.name)">{{men.body.name}}
        </md-button>-->
      <!--</div>-->
  </div>
  </div>
</template>

<script>
export default {
  name: 'BodyMen',
  props: {
    mens: {
      type: Array
    },
    dirServer: {
      type: String
    },
    user: {
      type: Object
    }
  },
  data () {
    return {
      some: ''
    }
  },
  methods: {
    openInNewTab (name) {
      var win = window.open(this.dirServer + '/uploads/' + name, '_blank')
      win.focus()
    },
    imageUrlAlt (event) {
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      var ret = ''
      if (name !== undefined) {
        ret = this.dirServer + '/uploads/' + name
      }
      return ret
    },
    isImage (file) {
      var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|'
      return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1
    },
    deleteMensaje (men, post) {
      if (window.confirm('Desea eliminar realmente')) {
        this.mens.splice(post, 1)
        // console.log('elimino')
      }
    },
    editMen (men) {
    // window.alert('editando mensaje')
    }
  }
}
</script>



// WEBPACK FOOTER //
// bodyMen.vue?0ca9cf9e